export const loader = {
    namespaced: true,
    state: {
      loader: false
    },
    actions: {
        showLoader ({ commit }, message) {
          commit('setLoadingState', true)
        },
        hideLoader ({ commit }, message) {
          commit('setLoadingState', false)
        }
    },
    mutations: {
        setLoadingState (state, loading) {
          state.loader = loading
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/loader.module.js